import { render } from "./arrow-clockwise.vue?vue&type=template&id=39b08b18"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/arrow-clockwise.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39b08b18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39b08b18', __exports__)) {
    api.reload('39b08b18', __exports__)
  }
  
  module.hot.accept("./arrow-clockwise.vue?vue&type=template&id=39b08b18", () => {
    api.rerender('39b08b18', render)
  })

}


export default __exports__